<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item :label="$t('server.id')" class="mb-0">
							<el-input size="small" v-model="from.username" ></el-input>
						</el-form-item>
						<el-form-item :label="$t('server.name')" class="mb-0">
							<el-input size="small" v-model="from.name"></el-input>
						</el-form-item>
						
						
						<el-form-item :label="$t('server.status')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('server.status0')" :value="0"></el-option>
								<el-option :label="$t('server.status1')" :value="1"></el-option>
								<el-option :label="$t('server.status2')" :value="2"></el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item :label="$t('server.type')" class="mb-0">
							<el-select v-model="from.type" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('server.type1')" :value="1"></el-option>
								<el-option :label="$t('server.type2')" :value="2"></el-option>
							</el-select>
						</el-form-item>
						
						
						<el-form-item :label="$t('accountList.cloudName')" class="mb-0">
							<el-select v-model="from.cloud_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						
						
						
						<el-form-item :label="$t('adminList.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" v-if="layout.user.type==1" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('server.add')}}</el-button>
						<el-button size="small"  type="danger"  v-if="layout.user.type==1" @click="deleteAll(false)" v-auth="'del'+auth_val" >{{$t('server.delDomain')}}</el-button>
						<el-button size="small"   v-if="layout.user.type==1" @click="pyStatus(false)" v-auth="'add'+auth_val" >{{$t('system.runStatus')}}</el-button>
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column align="center" type="index" :label="$t('adminList.sort')" width="50">
				</el-table-column> -->
				<el-table-column
				      type="selection"
				      width="45">
				    </el-table-column>
				
				<el-table-column fixed="left" align="center" prop="id"  :label="$t('userList.id')" width="60">
				</el-table-column>
				<!-- <el-table-column align="center" prop="name" width="50" :label="$t('adminList.avatar')">
					<template slot-scope="scope">
						<el-image 
							style="width: 40px; height: 40px"
							:src="scope.row.head" 
							:preview-src-list="check_img_list">
						</el-image>
					</template>
				</el-table-column> -->
				
				<el-table-column width="160" align="center" prop="in_id" :label="$t('server.id')">
				</el-table-column>
				
				<el-table-column width="180" align="center" prop="name" :label="$t('server.name')">
				</el-table-column>
				
				
				<el-table-column align="center" prop="server_status" :label="$t('server.status')">
					<template slot-scope="scope">
						<span style="color: #999;" v-if="scope.row.server_status==0">{{$t('server.status0')}}</span>
						<span class="text-info" v-if="scope.row.server_status==1">{{$t('server.status1')}}</span>
						<span class="text-danger" v-if="scope.row.server_status==2">{{$t('server.status2')}}</span>
					</template>
				</el-table-column>	

				
				
				<el-table-column width="100" align="center" prop="server_type" :label="$t('server.type')">
					<template slot-scope="scope">
						
						<span  v-if="scope.row.server_type==1">{{$t('server.type1')}}</span>
						<span  v-if="scope.row.server_type==2">{{$t('server.type2')}}</span>
						
					</template>
				</el-table-column>	

				
				<el-table-column align="center" prop="py_status" :label="$t('server.py_status')">
					<template slot-scope="scope">
						<div v-if="scope.row.server_type==1">
							<span class="text-info" > -- </span>
						</div>
						<div v-if="scope.row.server_type==2">
							<span class="text-info" v-if="scope.row.py_status==1">{{$t('server.py_status1')}}</span>
							<span class="text-danger" v-if="scope.row.py_status==2">{{$t('server.py_status2')}}</span>
						</div>

						
					</template>
				</el-table-column>	
				
				<el-table-column align="center" width="150" prop="ip" :label="$t('server.ip')">
					<template slot-scope="scope">
						
						<div v-if="scope.row.server_status==0">
							<span style="color: #999;">{{$t('cdn.status2')}}</span>
							<span @click="checkServerDetail(scope.row)" class="pl-1" style="color: #000;font-size: 18px;cursor: pointer;"><i :class="scope.row.load==0?'el-icon-refresh':'el-icon-loading'"></i></span>
						</div>
						
						<div v-else >
							<span class="ellipsis-text">{{ scope.row.ip }}</span>
							
							
							<span class="iconCopy" @click="copyText(scope.row.ip)"><i class="iconfont icon-fuzhi"></i></span>
						</div>
						
						
					</template>
				</el-table-column>
				
				
				<el-table-column align="center" width="100" prop="ssh_account" :label="$t('server.account')">
				</el-table-column>
				
				<el-table-column align="center" width="180" prop="password" :label="$t('server.pass')">
					<template slot-scope="scope">
						<span>{{scope.row.showPass==1?scope.row.password:scope.row.password2}}</span> <i class="el-icon-view ml-1" @click="changePassShow(scope.row)"></i>
					</template>
				</el-table-column>
				
				
				<el-table-column width="100" align="center" prop="cloud_name" :label="$t('accountList.cloudName')">
					
				</el-table-column>
						
		<el-table-column align="center" width="130" prop="private_ip" :label="$t('server.pip')">
		</el-table-column>
				
				
				<el-table-column align="center" width="100" prop="remark" :label="$t('server.remark')">
				</el-table-column>
				
				
				
				
				<el-table-column align="center" width="180" prop="create_time" :label="$t('adminList.createTime')">
				</el-table-column>
				
			
		
				
	
				
		
				<el-table-column :width="layout.user.type==1?200:200" fixed="right" prop="id" align="center" :label="$t('adminList.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<!-- <el-button :disabled="scope.row.server_status!=1" size="mini" plain v-auth="'editAdmin'" @click="lookLog(scope.row)">{{$t('system.look')}}</el-button> -->
							<el-button size="mini" plain type="primary" @click="openModel(scope.row)">{{ $t('layout.operation') }}</el-button>
							<el-button v-if="scope.row.py_status == 2" :disabled="scope.row.server_type==1" size="mini" plain type="success" v-auth="'editAdmin'" @click="run(scope.row)">{{$t('system.run')}}</el-button>
							<el-button v-if="scope.row.py_status == 1" :disabled="scope.row.server_type==1" size="mini" plain type="danger" v-auth="'editAdmin'" @click="run(scope.row)">{{$t('server.restart')}}</el-button>

							<el-button :disabled="scope.row.server_status!=1" size="mini" plain type="danger" v-auth="'editAdmin'" @click="deleteItem(scope.row)">{{$t('system.delete')}}</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>



		<el-footer
		  class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		  :style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		  >
		   <div style="flex: 1;" class="px-2">
		    <el-pagination
		    :current-page="page.current"
		    :page-sizes="page.sizes"
		    :page-size="page.size"
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    background
		    :layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
		    :total="page.total"
		    />
		   </div>
		  </el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('accountList.editAccount') : $t('accountList.addAccount')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				<!-- <el-form-item :label="$t('adminList.avatar')" prop="icon">
					<el-upload
						name="file"
						class="avatar-uploader"
						action="/admin/image/uploadNew"
						:headers="{token:$store.state.user.token}"
						:data="{type:'userHead'}"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload">
						<img v-if="form.icon" :src="form.icon" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item> -->
				
				
				<el-form-item :label="$t('accountList.cloudName')" prop="cloud_id">
					<el-select  :disabled="editIndex > -1" v-model="form.cloud_id" size="small" filterable :placeholder="$t('system.select')">
					
						<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				
				<el-form-item   :label="$t('server.type')">
					<el-radio-group  v-model="form.server_type" size="small">
						<el-radio :label="1" border>{{$t('server.type1')}}</el-radio>
						<el-radio :label="2" border>{{$t('server.type2')}}</el-radio>
					
					</el-radio-group>
				</el-form-item>
				
			
				
				<el-form-item v-if="editIndex == -1" :label="$t('server.num')" prop="num">
					<el-input v-model="form.num" @input="handleInput" type="number"  :placeholder="$t('server.num')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
			
				
				<el-form-item :label="$t('server.pass')" prop="password">
					<el-input v-model="form.password" show-password :placeholder="$t('server.pass_p')" size="small" auto-complete="new-password" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
			
				
				
	
				
				
				
				
			
				
			
				
				
				<el-form-item :label="$t('server.remark')" prop="remark">
					<el-input v-model="form.remark" :placeholder="$t('server.remark')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
			
				
				
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submit">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				editIndex: -1,
				
				//搜索數据
				from: {
					name: '',
					username:'',
					sup_id:-1,
					status:-1,
					get_status:-1,
					type:-1,
					cloud_id:-1,
					time:[],
				},
				auth_val: 'Admin',
				odds:0,
				preUrl: "data/serverList", //列表地址
				delAllUrl: "data/delServerAll", //批量删除地址
				delUrl: "data/delServer", //删除單条地址
				addUrl: "data/addServer", //添加/修改地址
				editStatusUrl:"data/editStatusServer",//修改狀態地址
				agentData:[],
				tableData: [],
				form: {},
				rules: {
					
					username: [{
						required: true,
						message: this.$t('adminList.usernameRequired'),
						trigger: 'blur',
					}],
					
					cloud_id: [{
						required: true,
						message: this.$t('accountList.selCloud'),
						trigger: 'blur',
					}],
					parent: [{
						required: true,
						message: this.$t('accountList.selMainAc'),
						trigger: 'blur',
					}],
					ac_id: [{
						required: true,
						message: this.$t('accountList.inp_ac_id'),
						trigger: 'blur',
					}],
					odds: [{
						required: true,
						message: this.$t('userList.inpOdds'),
						trigger: 'blur',
					}],
					sup_id:[{
						required: true,
						message: this.$t('new1.selSup'),
						trigger: 'blur',
					}],
				},
				rule_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList(['cloud']);
		},
		methods: {
			checkServerDetail(item) {
				console.log(item)
				if(item.load==1){
					return false;
				}
				item.load = 1;
				this.axios.post('/admin/data/checkServerDetail', {
					id:item.id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					console.log(list)
					
					item.ip = list.ip
					item.server_status	= list.server_status
					item.private_ip = list.private_ip
					
					item.load = 0;
				}).catch(err => {
					// 失敗
					item.load = 0;
				})
			},
			lookLog(item) {
				if(item.load==1){
					return false;
				}
				item.load = 1;
				this.axios.post('/admin/data/lookPyLog', {
					id:item.id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					console.log(list)
					
					item.ip = list.ip
					item.server_status	= list.server_status
					item.private_ip = list.private_ip
					
					item.load = 0;
				}).catch(err => {
					// 失敗
					item.load = 0;
				})
			},
			pyStatus(item) {
				this.layout.loading = true;
				this.axios.post('/admin/data/pyStatus', {
					ids:item.ids
				}, {
					token: true,
				}).then(res => {
					this.layout.loading = false;
					this.getList()
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			run(item) {
				this.layout.loading = true;
				this.axios.post('/admin/data/startPy', {
					id:item.id
				}, {
					token: true,
				}).then(res => {
					this.layout.loading = false;
					this.getList()
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			stopPy(item) {
				this.layout.loading = true;
				this.axios.post('/admin/data/stopPy', {
					id:item.id
				}, {
					token: true,
				}).then(res => {
					this.layout.loading = false;
					this.getList()
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			 handleInput(val) {
			    if (val > 20) {
			      this.form.num = 20;
			    }
			  },
			getMainAccount(e){
				this.commonList('account1',e);
			},
			getToUser(id){
				this.layout.getModel = true
				this.layout.getModelType = 1
				this.layout.getModelTypeId = id
			},
			checkLog(id){
				this.layout.logModel = true
				this.layout.logID = id
			},
			changePassShow(item){
				item.showPass = item.showPass==1?0:1
			},
			changeMoneyType(e){
				if(e==1){
					this.form.money = 0
				}
				//console.log(e)
			},
			//提交
			submit() {
				// if (this.form.password != this.form.password2) {
				// 	this.$message({
				// 		message: this.$t('adminList.differentPasswords'),
				// 		type: 'error'
				// 	});
				// 	return
				// }
				this.$refs.form.validate(res => {
					// if(!this.form.headUrl){
					// 	this.$message.error(this.$t('adminList.upProfile'));
					// 	return false
					// }
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},

			// 打开模态框
			openModel(e = false) {
				// 增加
				console.log(e)
				if (!e) {
					// 初始化表單
					this.form = {
						id:0,
						num: 1,
						password: '',
						server_type:1,
						remark:''
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						id:e.id,
						cloud_id: e.cloud_id,
						server_type:e.server_type,
						sup_id: e.sup_id,
						focus:e.focus,
						username: e.username,
						password: e.password,
						status: e.status,
						odds: e.odds,
						type: e.type,
						ac_id: e.ac_id,
						parent: e.parent,
						money:e.money,
						access_key_id:e.access_key_id,
						secret_access_key:e.secret_access_key,
						money_type:e.money_type,
						remark:e.remark
					}
					this.editIndex = e.id
				}
				
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(type,id=0) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
					id:id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					this.agentData.cloud = list.cloud
					
					this.odds = list.user_odds
					
					
					
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
							const isJPG = file.type === 'image/jpeg';
							const isLt2M = file.size / 1024 / 1024 < 2;
					
							// if (!isJPG) {
							//   this.$message.error('上傳头像图片只能是 JPG 格式!');
							// }
							// if (!isLt2M) {
							//   this.$message.error('上傳头像图片大小不能超過 2MB!');
							// }
							return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					username:'',
					status:-1,
					get_status:-1,
					type:-1,
					cloud_id:-1,
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}
</style>
